export const GLOBAL_ALERT_KEY = "global-toast";
